export default "__VITE_ASSET__CMttec_$__"